(() => {
  const page = document.documentElement;
  let resizeObserver;
  const bindSticky = () => {
    resizeObserver?.disconnect();
    const sticky = document.querySelector('.sfg-surface .stickyCta');
    page.classList.toggle('sfg-has-sticky', Boolean(sticky));
    if (!sticky) {
      page.style.removeProperty('--sfg-sticky-height');
      return;
    }
    const resize = () => page.style.setProperty('--sfg-sticky-height', `${sticky.getBoundingClientRect().height}px`);
    resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(sticky);
    resize();
  };
  bindSticky();
  document.addEventListener('shopify:section:load', bindSticky);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(bindSticky));
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.sfg-product-form');
    if (!form) return;
    const button = form.querySelector('[type="submit"]');
    if (button.dataset.submitted) {
      event.preventDefault();
      return;
    }
    button.dataset.submitted = 'true';
    button.setAttribute('aria-busy', 'true');
    queueMicrotask(() => button.disabled = true);
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.sfg-product-form [data-submitted]').forEach((button) => {
      delete button.dataset.submitted;
      button.removeAttribute('aria-busy');
      button.disabled = false;
    });
  });
})();
